'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCheckmark = function IoCheckmark(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 8.6c0.1 0.2 0.2 0.3 0.2 0.5s-0.1 0.3-0.2 0.4l-19.4 25c-0.2 0.2-0.4 0.5-0.7 0.5s-0.6-0.2-0.8-0.4-11-10.6-11-10.6l-0.2-0.2c-0.1-0.2-0.2-0.4-0.2-0.5s0.1-0.3 0.2-0.4l0.1-0.2c1.1-1.1 3.3-3.4 3.5-3.6s0.3-0.4 0.6-0.4 0.6 0.3 0.8 0.4 6.2 6.1 6.2 6.1l15.6-20c0.2-0.2 0.3-0.2 0.5-0.2s0.4 0.1 0.5 0.2z' })
        )
    );
};

exports.default = IoCheckmark;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/checkmark.js
// module id = 2014
// module chunks = 0